const AUTH_KEY = {
  SESSION_EXPIRED: "session_expired",
};

export default AUTH_KEY;
